import React, { useEffect, useState } from "react";
import { client, API, fmtTimeAST } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Download, FileText } from "lucide-react";

export default function Export() {
  const [jobs, setJobs] = useState([]);
  useEffect(() => {
    client.get("/jobs").then(r => setJobs(r.data.filter(j => j.status === "complete")));
  }, []);

  const download = async () => {
    const r = await client.get("/export/quickbooks", { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `quickbooks-export-${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(a); a.click(); a.remove();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="export-page">
      <div className="mono text-[11px] uppercase tracking-widest" style={{ color: "#5B6472" }}>Finance</div>
      <h1 className="text-[28px] font-bold" style={{ color: "#12161B", letterSpacing: "-0.022em", marginTop: "6px" }}>QuickBooks Export</h1>
      <p className="text-[13.5px] mt-1" style={{ color: "#5B6472", lineHeight: 1.5 }}>Completed jobs are matched to QuickBooks customer names and IDs. CSV only — no direct QB write yet.</p>

      <div className="mt-7 bf-card flex items-center gap-4" style={{ padding: "18px" }}>
        <FileText size={28} color="#2563EB" />
        <div className="flex-1">
          <div className="font-medium text-[15px]">{jobs.length} completed job{jobs.length !== 1 ? "s" : ""} ready to export</div>
          <div className="text-[13px]" style={{ color: "#5B6472", lineHeight: 1.5 }}>Includes ticket, QB name/ID, labour hours, parts (with covered flag), serial, coverage status.</div>
        </div>
        <Button className="h-10 px-4 bf-btn-primary" onClick={download} data-testid="download-csv-btn">
          <Download size={16} className="mr-2" /> Download CSV
        </Button>
      </div>

      <div className="mt-6 bg-white rounded-[14px] overflow-hidden" style={{ boxShadow: "0 1px 2px rgba(16,24,32,.06), 0 6px 18px rgba(16,24,32,.045)" }}>
        <table className="w-full text-[13.5px]">
          <thead>
            <tr style={{ background: "#F7F8FA" }}>
              <th className="th-condensed text-left px-3 py-2">Ticket</th>
              <th className="th-condensed text-left px-3 py-2">Completed</th>
              <th className="th-condensed text-left px-3 py-2">Labour (h)</th>
              <th className="th-condensed text-left px-3 py-2">Parts</th>
            </tr>
          </thead>
          <tbody>
            {jobs.map(j => (
              <tr key={j.id} className="border-t" style={{ borderColor: "#EFF1F4" }}>
                <td className="px-3 py-2.5 mono">{j.ticket_number}</td>
                <td className="px-3 py-2.5 mono">{fmtTimeAST(j.completed_at)}</td>
                <td className="px-3 py-2.5 mono">{j.labour_hours}</td>
                <td className="px-3 py-2.5">{(j.parts_used || []).map(p => `${p.name} ×${p.qty}`).join(", ") || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
